<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Manage Price List</v-toolbar-title>
                <v-btn text color="accent" :loading="loader" style="padding-left: 50px"
                    @click.native="updateUomGroupPriceList"><v-icon left>mdi-content-save</v-icon> Update Uom
                    Group Price List</v-btn>
                <v-spacer></v-spacer>
                <v-btn small text to="/price-lists">
                    <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <v-row>
                    <v-text-field name="priceListSearch" v-model="search" append-icon="mdi-magnify" label="Search"
                        single-line hide-details></v-text-field>
                </v-row>

                <v-row dense class="mt-4">
                    <v-col cols="12">
                        <!-- excel icon -->
                        <download-excel :data="priceLists" :fields="fields" name="Products List">
                            <v-icon color="green">mdi-file-excel</v-icon>
                        </download-excel>
                        <!-- end -->
                    </v-col>

                    <v-col cols="12" md="6">
                        <div class="style-18" style="color: blue">{{ priceListName }}</div>
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-btn class="float-right" text color="primary" @click.native="copyUomDialog = true">
                            <v-icon left>mdi-plus</v-icon>Copy Uom Setup</v-btn>
                    </v-col>

                </v-row>

                <v-divider></v-divider>

                <v-row>

                    <v-col cols="12">


                        <v-data-table :items-per-page="pageItems" :headers="headers" :items="priceLists"
                            :search="search">

                            <!-- action template -->
                            <template v-slot:item.action="{ item }">
                                <v-btn v-show="item.HasUom == 0" color="primary" text @click="openEditModal(item)">
                                    <v-icon left>mdi-pencil</v-icon> Edit Price
                                </v-btn>

                                <v-btn v-show="item.HasUom == 1" color="accent" text @click="openUomPriceModal(item)">
                                    <v-icon left>mdi-cog-outline</v-icon> Manage Uom Prices
                                </v-btn>
                            </template>
                            <!-- end -->

                            <!-- action template -->
                            <template v-slot:item.disable="{ item }">
                                <v-btn color="red" @click="openDeleteModal(item)" text><v-icon left>mdi-close</v-icon>
                                    Disable Product
                                </v-btn>
                            </template>
                            <!-- end -->
                        </v-data-table>
                    </v-col>
                </v-row>

                <!-- product dialog modal-->
                <v-dialog v-model="deleteDialog" max-width="750px">
                    <v-card>
                        <v-toolbar dense color="secondary" flat>
                            <v-toolbar-title> Delete / Disable Product </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click.native="deleteDialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-container fluid>
                                <v-row class="text--primary subtitle-2">
                                    <v-col cols="12">
                                        Are you sure you want to delete / disable this product?
                                    </v-col>
                                    <v-col cols="12">
                                        <span style="font-size: 20px">{{ productItem.Name }}</span>
                                    </v-col>

                                    <v-col cols="12">
                                        <span style="font-size: 18px">Available Qty: {{ productItem.AvailableQty
                                            }}</span>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-btn color="red" dark :loading="loader" @click="deleteProduct">Yes,
                                            Disable</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <!-- end of modal-->

                <!-- price list edit dialog -->
                <v-dialog v-model="editDialog" max-width="750px">
                    <v-card>
                        <v-toolbar dense color="secondary" flat>
                            <v-toolbar-title>Edit Product Price</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click.native="editDialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-container fluid>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="style-16">{{ editRecord.Name }}</span>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-text-field outlined dense label="Buying Price"
                                            v-model="editRecord.BuyingPrice"></v-text-field>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-text-field outlined dense label="Selling Price"
                                            v-model="editRecord.SellingPrice"></v-text-field>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-text-field outlined dense label="Least Price"
                                            v-model="editRecord.LeastPrice"></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-btn color="primary" @click="updatePrices" :loading="loader">
                                            <v-icon left>mdi-content-save</v-icon> Update Price
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <!-- end of edit modal-->


                <!-- ugp1 modal -->
                <v-dialog v-model="ugp1Dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                    <v-card class="grey lighten-3">
                        <v-toolbar dense flat color="primary" dark elevation="2">
                            <v-icon left>mdi-file-document-outline</v-icon>
                            <v-toolbar-title>{{ priceListName }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="ugp1Dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card-text class="pa-0" style="height: calc(100vh - 48px); overflow-y: auto;">
                            <v-container fluid>
                                <v-row justify="center">
                                    <v-col cols="12" md="8" lg="8" xl="8" style="margin-top: 50px">
                                        <div class="style-18">Product: <span style="color: red"> <strong
                                                    class="font-weight-medium">{{
                                                        selectedUomProduct }}</strong></span></div>
                                    </v-col>
                                    <v-col cols="12" md="8" lg="8" xl="8">
                                        <v-data-table :items-per-page="2000" :headers="ugp1Headers" :items="ugp1Data"
                                            :mobile-breakpoint="0" hide-default-footer>
                                            <!-- action template -->
                                            <template v-slot:item.BaseQty="{ item }">
                                                <span v-show="docCreate == true">{{ item.BaseQty }}</span>
                                                <span v-show="docCreate == false">{{ item.BaseQty }}</span>
                                            </template>
                                            <!-- end -->

                                            <!-- action template -->
                                            <template v-slot:item.action="{ item }">
                                                <v-btn color="primary" text icon>
                                                    <v-btn color="accent" text icon @click="openEditUgp1Modal(item)">
                                                        <v-icon>mdi-pencil</v-icon>
                                                    </v-btn>
                                                </v-btn>
                                            </template>
                                            <!-- end -->
                                        </v-data-table>


                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                <!-- end of ugp1 modal -->

                <!-- editing dialog -->
                <v-dialog v-model="ugp1EditDialog" max-width="750px">
                    <v-form ref="uomEditForm">
                        <v-card>
                            <v-toolbar dense color="secondary" flat>
                                <v-toolbar-title>Edit - <span style="color: red;">{{ priceListName
                                }}</span></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click.native="ugp1EditDialog = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-container fluid>
                                    <v-row>
                                        <v-col cols="12" xs="12" sm="12" md="12">
                                            <span class="style-18">{{ ugp1Record.uom && ugp1Record.uom.UomName }}</span>
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="12" md="6">
                                            <v-text-field type="number" label="Buying Price" outlined dense
                                                v-model="ugp1Record.BuyingPrice"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="12" md="6">
                                            <v-text-field type="number" label="Selling Price" outlined dense
                                                v-model="ugp1Record.SellingPrice"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="12" md="6">
                                            <v-text-field label="Least Selling Price" outlined dense
                                                v-model="ugp1Record.LeastPrice" type="number"></v-text-field>
                                        </v-col>


                                        <v-col cols="12">
                                            <v-btn color="primary" @click="updateDef" :loading="loader">
                                                <v-icon left>mdi-content-save</v-icon>Update Prices
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </v-dialog>
                <!-- end of editing dialog -->

                <!-- copy uom data  dialog -->
                <v-dialog v-model="copyUomDialog" max-width="650px">
                    <v-form ref="uomCopyForm">
                        <v-card>
                            <v-toolbar dense color="secondary" flat>
                                <v-toolbar-title>Copy Uom Setup</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click.native="copyUomDialog = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-container fluid>
                                    <v-row>
                                        <v-col cols="12" xs="12" sm="12" md="12">
                                            <span class="style-18">Copy To: {{ priceListName }}</span>
                                        </v-col>

                                        <v-col cols="12" md="12">
                                            <v-autocomplete autocomplete="off" name="copyPriceList" hide-details dense
                                                outlined v-model="copyFromPriceListId" :items="allPriceLists"
                                                label="Copy From (Price List)" item-text="Name"
                                                item-value="id"></v-autocomplete>
                                        </v-col>


                                        <v-col cols="12">
                                            <v-btn color="primary" @click="copyUomSetup" :loading="loader">
                                                <v-icon left>mdi-content-save</v-icon> Copy Uom Setup
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </v-dialog>
                <!-- end of copy uom data dialog -->


                <snackbar ref="snackbar"></snackbar>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    computed: {
        activeStore() {
            return localStorage.getItem("store_id");
        },
        subscriberId() {
            return localStorage.getItem("subscriber_id");
        }
    },
    data: () => ({
        search: "",
        priceListName: "",
        selectedUomProduct: "",
        copyFromPriceListId: null,
        loader: false,
        deleteDialog: false,
        copyUomDialog: false,
        ugp1EditDialog: false,
        ugp1Record: {},
        pageItems: 100,
        editRecord: {},
        productItem: {},
        editDialog: false,
        ugp1Dialog: false,
        ugp1Data: [],
        headers: [
            { text: "Item Code", value: "ItemCode" },
            { text: "Product Name", value: "Name" },
            { text: "Category", value: "category" },
            { text: "Available", value: "AvailableQty" },
            { text: "Buying Price", value: "BuyingPrice" },
            { text: "Selling price", value: "SellingPrice" },
            { text: "Least Price", value: "LeastPrice" },
            { text: "Action", value: "action" },
            { text: "Disable", value: "disable" }
        ],
        ugp1Headers: [
            { text: "Uom Unit", value: "uom.UomName" },
            { text: "Buying Price", value: "BuyingPrice" },
            { text: "Selling Price", value: "SellingPrice" },
            { text: "Least Price", value: "LeastPrice" },
            { text: "Action", value: "action" },
        ],
        fields: {
            ItemCode: "ItemCode",
            Product: "Name",
            Category: "category",
            BuyingPrice: "BuyingPrice",
            SellingPrice: "SellingPrice",
            LeastPrice: "LeastPrice",
        },
        priceLists: [],
        allPriceLists: []
    }),
    methods: {
        openEditModal(item) {
            this.editRecord = item;
            this.editDialog = true;
        },
        openEditUgp1Modal(item) {
            this.ugp1Record = item;
            this.ugp1EditDialog = true;
        },
        openDeleteModal(data) {
            this.productItem = data;
            this.deleteDialog = true;
        },
        updatePrices() {
            var rowId = this.editRecord.rowId;
            var editedData = this.editRecord;
            var data = {
                "id": parseInt(rowId),
                "BuyingPrice": parseFloat(editedData.BuyingPrice),
                "SellingPrice": parseFloat(editedData.SellingPrice),
                "LeastPrice": parseFloat(editedData.LeastPrice)
            };

            const url = `/product-prices-update`;
            const self = this;
            self.loader = true;
            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.editDialog = false;
                        self.$refs.snackbar.show("Price updated successfully", "green");
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    self.loader = false;
                    self.$refs.snackbar.show(err, "red");
                });
        },
        openUomPriceModal(data) {
            this.selectedUomProduct = data.Name;
            var productId = data.ProductId;
            var priceListId = data.PriceListId;
            const url = `/get-product-ugp1-setup/${productId}/${priceListId}`;
            const self = this;
            self.loader = true;
            this.$store
                .dispatch("get", url)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.ugp1Data = res.ResponseData;
                        self.ugp1Dialog = true;
                        self.loader = false;
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    self.loader = false;
                    self.$refs.snackbar.show(err, "red");
                });
        },
        getData() {
            const self = this;
            const id = this.$route.params.id;
            const storeId = this.activeStore;
            this.$store
                .dispatch("get", `/price-list-data/${id}/${storeId}`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.priceLists = res.ResponseData.priceListData;
                        self.priceListName = res.ResponseData.name;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        copyUomSetup() {
            const self = this;
            const copyToId = parseInt(this.$route.params.id);
            const copyFromId = parseInt(this.copyFromPriceListId);

            this.$store
                .dispatch("get", `/copy-uom-setup/${copyToId}/${copyFromId}`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.copyUomDialog = false;
                        self.$refs.snackbar.show("Uom Setup copied successfully", "green");
                    } else {
                        self.loader = false;
                        self.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(err => {
                    self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                });
        },
        updateUomGroupPriceList() {
            const self = this;
            this.loader = true;
            const url = `/update-uom-group-price-list/${this.subscriberId}`;
            self.loader = true;
            this.$store
                .dispatch("get", url)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.$refs.snackbar.show("Uom Group Price List updated successfully", "green");
                        self.getData();
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    self.loader = false;
                    self.$refs.snackbar.show(err, "red");
                });
        },
        deleteProduct() {
            const url = `/delete/product/${this.productItem.id}`;
            const self = this;
            this.loader = true;
            this.$store
                .dispatch("remove", url)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.deleteDialog = false;
                        self.$refs.snackbar.show("Product deleted successfully", "green");
                        self.getData();
                    } else {
                        self.loader = false;
                        self.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    self.loader = false;
                    self.$refs.snackbar.show(err, "red");
                });
        },
        updateDef() {
            var data = {
                id: parseInt(this.ugp1Record.id),
                BuyingPrice: parseFloat(this.ugp1Record.BuyingPrice),
                SellingPrice: parseFloat(this.ugp1Record.SellingPrice),
                LeastPrice: parseFloat(this.ugp1Record.LeastPrice)
            };

            const url = "/edit-ugp1-prices";
            const self = this;
            this.loader = true;
            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.ugp1EditDialog = false;
                        self.loader = false;
                        self.getUgp1Records(this.ugp1Record.ProductId, this.ugp1Record.PriceListId);
                        self.$refs.snackbar.show("Uom prices updated successfully", "green");
                    } else {
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                        this.loader = false;
                    }
                })
                .catch(() => {
                    this.loader = false;
                });
        },
        getUgp1Records(productId, priceListId) {
            const url = `/get-product-ugp1-setup/${productId}/${priceListId}`;
            const self = this;
            self.loader = true;
            this.$store
                .dispatch("get", url)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.ugp1Data = res.ResponseData;
                        self.loader = false;
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    self.loader = false;
                    self.$refs.snackbar.show(err, "red");
                });
        },
        getPriceLists() {
            const self = this;
            this.$store
                .dispatch("get", `/price-list`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.allPriceLists = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
    },
    created() {
        this.getData();
        this.getPriceLists();
    }
};
</script>